<template>
  <div class="box vector-match-test">
    <h3 class="title is-5">Vector Match Test</h3>
    <p class="subtitle is-7">
      Pulls the real applicant record (CV, job title, skills, region, salary) via
      rebase_server's admin endpoint, embeds it, and ranks matching hot positions.
    </p>

    <form @submit.prevent="runMatch" class="field is-grouped">
      <div class="control">
        <input
          v-model="applicantId"
          type="text"
          inputmode="numeric"
          class="input"
          placeholder="Applicant ID"
          required
        />
      </div>
      <div class="control">
        <input
          v-model="limit"
          type="text"
          inputmode="numeric"
          class="input"
          style="width: 90px"
          placeholder="Limit"
        />
      </div>
      <div class="control">
        <button type="submit" class="button is-info" :disabled="isLoading">
          {{ isLoading ? 'מחפש...' : 'Match' }}
        </button>
      </div>
    </form>

    <p v-if="errorMessage" class="has-text-danger">{{ errorMessage }}</p>
    <p v-else-if="result" class="status-line">
      applicant_id: {{ result.applicant_id }} — {{ result.count }} match(es)
    </p>

    <table v-if="result && result.positions && result.positions.length" class="table is-fullwidth is-striped">
      <thead>
        <tr>
          <th>Position ID</th>
          <th>Title</th>
          <th>Company</th>
          <th>Score</th>
          <th>Cosine sim</th>
          <th>Cosine title</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="p in result.positions" :key="p.position_id">
          <td>{{ p.position_id }}</td>
          <td>{{ p.title }}</td>
          <td>{{ p.company_name }}</td>
          <td>{{ p.score }}</td>
          <td>{{ p.cosine_sim }}</td>
          <td>{{ p.cosine_title }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'VectorMatchTest',
  data () {
    return {
      applicantId: '',
      limit: '10',
      isLoading: false,
      result: null,
      errorMessage: ''
    }
  },
  methods: {
    runMatch () {
      this.isLoading = true
      this.errorMessage = ''
      this.result = null
      this.$caller.request('get', '/embedding_position_matches', 'admin_headers', {
        applicant_id: this.applicantId,
        limit: this.limit || 10
      }).then(response => {
        this.result = response
      }).catch(err => {
        this.errorMessage = (err.response && err.response.data && err.response.data.error) || err.message
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
.vector-match-test {
  max-width: 900px;
}
.status-line {
  color: #666;
  margin-bottom: 0.75rem;
}
</style>
